import { Switch } from '@mui/material';
import GemsIcon from 'src/assets/icons/Store/GemsSecondary.svg';
import {
  CopyStack,
  IconChip,
  Subtitle,
  Title,
  ToggleRow,
} from './GemsDiscountToggle.styles';

// Shared between PricingDetails (desktop checkout + Cart) and
// CheckoutMobileView so both surfaces offer the same "use my gems" discount
// with identical math and styling.
const GemsDiscountToggle = ({
  gemsToApply,
  checked,
  disabled,
  onChange,
}: {
  gemsToApply: number;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) => {
  if (gemsToApply <= 0) return null;

  return (
    <ToggleRow>
      <IconChip>
        <img src={GemsIcon} height="22px" />
      </IconChip>
      <CopyStack>
        <Title>Use gems</Title>
        <Subtitle>Pay up to ₹{gemsToApply} with gems</Subtitle>
      </CopyStack>
      <Switch
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
    </ToggleRow>
  );
};

export default GemsDiscountToggle;
